import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Client, ClientContract } from 'src/app/models/client.model';
import { RefundLine, RefundModel } from 'src/app/models/refund.model';
import { Connection } from 'src/app/models/server-v2';
import { DbService } from 'src/app/services/data/idb.service';
import { ReturnDbService } from 'src/app/services/data/return-db.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-create-refund',
  templateUrl: './create-refund.component.html',
  styleUrls: ['./create-refund.component.scss'],
})
export class CreateRefundComponent {
  buypoinId = '';
  agent: Connection | undefined;

  buypoint: Client | undefined;
  error = false;
  createError = false;

  deliveryComment = '';
  delivery: Date | undefined;
  anal: number;

  pickup = false;

  private refundDb: ReturnDbService;
  private db: DbService;
  contracts: ClientContract[] = [];
  org: FormControl = new FormControl('');
  minDate: Date;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public cm: ConnectionManagerService,
    private snack: MatSnackBar
  ) {
    this.anal = 0;

    this.db = cm.getCurrentDb();
    this.refundDb = new ReturnDbService(this.db);

    this.minDate = new Date(); 
    this.minDate.setDate(this.minDate.getDate() + 1);
  }

  ngOnInit(): void {
    this.anal = 0;

    this.route.paramMap.subscribe((params) => {
      this.buypoinId = params.get('id') as string;

      this.agent = this.cm.activeServer;

      this.db.getClient(this.buypoinId).subscribe((val) => {
        if (!val) {
          return;
        }
        this.buypoint = val;
        this.loading = false;
        this.contracts = val.contracts;

        if (this.contracts?.length === 1) {
          this.org.setValue(this.contracts[0].organizationId);
        }
      });
    });
  }

  loading = true;

  public doCreateOrder() {
    if (!this.agent) {
      this.snack.open('Не определён агент. Обновите страницу', 'ok', {
        duration: 3800,
      });
      return;
    }

    if (!this.org.value) {
      this.org.setErrors([Validators.required]);
      this.org.markAsTouched();
      this.snack.open('Не выбрана организация!', 'ok', { duration: 3800 });
      return;
    }

    if (this.buypoinId !== undefined) {
      this.loading = true;
      this.createError = false;

      const view = {
        buypoint: this.buypoint?.name,
        buypointId: this.buypoinId,
        agentId: this.agent.agent.Id,
        deliveryComment: this.deliveryComment,
        dateDelivery: this.delivery,
        date: new Date(),
        statusId: 1,
        firm:
          this.contracts.find((x) => x.organizationId === this.org.value)
            ?.organization ?? '',
        firmId: this.org.value,
        isPickup: this.pickup,
        items: [] as RefundLine[],
      } as RefundModel;

      this.refundDb
        .createRefund(view)

        .subscribe({
          next: (refund) => {
            void this.router.navigate(['/edit-refund', refund.id]);
          },
          error: (serror) => {
            this.createError = true;
            this.loading = false;
            this.snack.open(serror, 'ok', { duration: 3800 });
          },
        });
    }
  }
}
